import SalesResultSection from './SalesResultSection';
export default SalesResultSection;
